// #region imports

// --- Angular
import {
  Component,
} from '@angular/core';

// #endregion

@Component({
  selector: 'hs-respondents-widget-group',
  templateUrl: './respondents-widget-group.component.html',
  styleUrls: ['./respondents-widget-group.component.scss']
})
export class RespondentsWidgetGroupComponent {
}
